import React from 'react';

const Focus = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>直拍链接合集</h2>
      <p>这里将展示夏沫的直拍链接合集内容。</p>
    </div>
  );
};

export default Focus;